export default {
  error: state => state.error,
  formLoading: state => state.formLoading,
  success: state => state.success,
  loading: state => state.loading,
  question: state => state.question,
  questions: state => state.questions,
  userQuestion: state => state.userQuestion,
};



// WEBPACK FOOTER //
// ./src/components/Syndicates/Syndicate/Forum/getters.js